import React, {useRef, useState, useLayoutEffect} from 'react';
import PropTypes from 'prop-types';

const DEFAULT_THUMBNAIL_SIZE = 100;
const SCROLL_PERCENT = 0.4; // Scroll 40% of available width.

/**
 * Review Image Slider
 * A component that adds a horizontal slider of images to a reviews row.
 */
const ImageSlider = (props) => {
  if (!props.images.length) return null;
  const containerRef = useRef(null);
  const imagesRef = useRef(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (containerRef.current) setWidth(containerRef.current.offsetWidth);
  }, []);

  const scroll = (scrollOffset) => imagesRef.current.scrollLeft += scrollOffset;

  const isHidden = () => {
    if (width === 0) return true;
    const imageSize = props.thumbnailSize ? props.thumbnailSize : DEFAULT_THUMBNAIL_SIZE;
    const margin = 4; // 0.25rem = ~4px
    const chevronButtonWidths = 30 * 2; // left and right buttons
    const maxImagesThatFit = Math.floor((width - chevronButtonWidths) / (imageSize + margin));
    return props.images.length < maxImagesThatFit;
  };

  const renderImages = () => {
    return props.images.map((image, index) => {
      return (
        <div key={image.idx} className={`${index === 0 ? "clickable mr-1 my-1" : "m-1 clickable"}`} onClick={() => props.onImageClick(image)} >
          <img
            className="rounded"
            style={{width: props.thumbnailSize || DEFAULT_THUMBNAIL_SIZE, height: props.thumbnailSize || DEFAULT_THUMBNAIL_SIZE, objectFit: "cover"}}
            src={image.imageUrl}
            alt={`review-image-${image.idx}`}
          />
        </div>
      );
    });
  };

  return (
    <div ref={containerRef} className="flex flex-row justify-content-between">
      <button hidden={isHidden()} className="m-2 btn btn-transparent" onClick={() => scroll(-width * SCROLL_PERCENT)}>
        <span className="far fa-chevron-left" />
      </button>
      <div ref={imagesRef} className="flex flex-row overflow-auto overflow-hidden mt-2 mb-2 w-100" style={{scrollBehavior: "smooth"}} >
        { renderImages() }
      </div>
      <button hidden={isHidden()} className="m-2 btn btn-transparent" onClick={() => scroll(width * SCROLL_PERCENT)}>
        <span className="far fa-chevron-right" />
      </button>
    </div>
  );
};

ImageSlider.propTypes = {
  images: PropTypes
    .arrayOf(PropTypes.shape({idx: PropTypes.number.isRequired, imageUrl: PropTypes.string.isRequired}))
    .isRequired,
  onImageClick: PropTypes.func.isRequired,
  thumbnailSize: PropTypes.number
};

export default ImageSlider;
